import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { BOOKINGS_APP_DEF_ID } from '../consts/applicationIdentities';
import { ApiContext } from './types';
import { getUpcoming } from './implementations/getUpcoming';
import { getHistory } from './implementations/getHistory';
import { CancelSingleArgs, cancelSingle } from './implementations/cancelSingle';
import { CancelGroupArgs, cancelGroup } from './implementations/cancelGroup';
import { Bookings } from '../types';
import { isSSR } from './implementations/isSSR';
import { GetAggregatedInfoResponse } from '@wix/ambassador-bookings-catalog-v1-business-info/types';
import { getBusinessInfo } from './implementations/getBusinessInfo';
import {
  ListResourcesByTagNameArgs,
  listResourcesByTagName,
} from './implementations/listResourcesByTagName';
import { getEnvironmentModes } from './implementations/environmentModes';
import {
  listTransactionsForMultipleEcomOrders,
  ListTransactionsForMultipleOrdersArgs,
} from './implementations/listTransactionsForMultipleOrders';
import { ListTransactionsForMultipleOrdersResponse } from '@wix/ambassador-ecom-v1-order-transactions/types';
import {
  CancelBookingResponse,
  CancelMultiServiceBookingResponse,
} from '@wix/ambassador-bookings-v2-booking/types';
import {
  queryEcomOrders,
  QueryEcomOrdersArgs,
} from './implementations/queryOrders';
import { QueryOrderResponse } from '@wix/ambassador-ecom-v1-order/types';

export class Api {
  private readonly flowAPI: ControllerFlowAPI;

  constructor({ flowAPI }: { flowAPI: ControllerFlowAPI }) {
    this.flowAPI = flowAPI;
  }

  private getApiContext(): ApiContext {
    return {
      flowAPI: this.flowAPI,
      authorization: this.getAuthorization(),
    };
  }

  private getAuthorization() {
    const { controllerConfig } = this.flowAPI;
    return (
      (controllerConfig.wixCodeApi.site.getAppToken
        ? controllerConfig.wixCodeApi.site.getAppToken(BOOKINGS_APP_DEF_ID)
        : undefined) || controllerConfig.appParams.instance
    );
  }

  async getUpcoming(): Promise<Bookings> {
    return getUpcoming({
      ...this.getApiContext(),
    });
  }

  async getHistory(): Promise<Bookings> {
    return getHistory({
      ...this.getApiContext(),
    });
  }

  async cancelSingle(args: CancelSingleArgs): Promise<CancelBookingResponse> {
    return cancelSingle({
      ...args,
      ...this.getApiContext(),
    });
  }

  async cancelGroup(
    args: CancelGroupArgs,
  ): Promise<CancelMultiServiceBookingResponse> {
    return cancelGroup({
      ...args,
      ...this.getApiContext(),
    });
  }

  async getBusinessInfo(): Promise<GetAggregatedInfoResponse> {
    return getBusinessInfo(this.getApiContext());
  }

  async listResourcesByTagName(args: ListResourcesByTagNameArgs) {
    return listResourcesByTagName({
      ...args,
      ...this.getApiContext(),
    });
  }

  async listTransactionsForMultipleOrders(
    args: ListTransactionsForMultipleOrdersArgs,
  ): Promise<ListTransactionsForMultipleOrdersResponse> {
    return listTransactionsForMultipleEcomOrders({
      ...args,
      ...this.getApiContext(),
    });
  }

  async queryOrders(args: QueryEcomOrdersArgs): Promise<QueryOrderResponse> {
    return queryEcomOrders({
      ...args,
      ...this.getApiContext(),
    });
  }

  isSSR() {
    return isSSR(this.getApiContext());
  }

  getEnvironmentModes() {
    return getEnvironmentModes({
      ...this.getApiContext(),
    });
  }
}
